module.exports = __webpack_public_path__ + "img/logo.c540b209.png";